import { render, staticRenderFns } from "./HorizontalBarchart.vue?vue&type=template&id=7a461ede"
import script from "./HorizontalBarchart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarchart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports